import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  ArrowRight,
  ChevronRight,
  Smartphone,
  Globe,
  Server,
  Database,
  Brain,
  Cloud,
  Plug,
  TestTube,
  Briefcase,
  DollarSign,
  Clock,
  ChevronDown,
  HelpCircle,
  Users,
} from "lucide-react";
import {
  INDUSTRIES,
  CASE_STUDIES,
  SERVICE_BUNDLES,
  INDIVIDUAL_SERVICES,
} from "../data/mock";
import { TEAM_IMAGES } from "@/data/teamImages";
// Integration logos (src/assets/technology_logo)
import aadhaarLogo from "../assets/technology_logo/aadhar.png";
import amazonCognitoLogo from "../assets/technology_logo/amazon.png";
import appPurchaseLogo from "../assets/technology_logo/app_purchase.png";
import applePayLogo from "../assets/technology_logo/applepay.png";
import auth0Logo from "../assets/technology_logo/auth.png";
import awsLogo from "../assets/technology_logo/Amazon-Web-Services-AWS-Symbol.png";
import bluetoothLogo from "../assets/technology_logo/bluetooth.png";
import braintreeLogo from "../assets/technology_logo/braintree.png";
import bugsnagLogo from "../assets/technology_logo/bugsnag.png";
import connexpayLogo from "../assets/technology_logo/conne.png";
import experianLogo from "../assets/technology_logo/experian.png";
import firebaseLogo from "../assets/technology_logo/firebase.png";
import googleMapsLogo from "../assets/technology_logo/google_maps_platform.png";
import googlePayLogo from "../assets/technology_logo/googlepay.png";
import googleWalletLogo from "../assets/technology_logo/google_wallett.png";
import jwPlayerLogo from "../assets/technology_logo/jw_player.png";
import kountLogo from "../assets/technology_logo/kount.png";
import lottieFilesLogo from "../assets/technology_logo/lattie_files.png";
import mixpanelLogo from "../assets/technology_logo/mix_pannel.png";
import nfcLogo from "../assets/technology_logo/nfc.png";
import openWeatherLogo from "../assets/technology_logo/open_whether.png";
import paypalLogo from "../assets/technology_logo/paypal.png";
import plaidLogo from "../assets/technology_logo/plaid.png";
import scanditLogo from "../assets/technology_logo/scandit.png";
import smartlookLogo from "../assets/technology_logo/smart_talk.png";
import squareLogo from "../assets/technology_logo/squre.png";
import stripeLogo from "../assets/technology_logo/stripe.png";
import uxcamLogo from "../assets/technology_logo/uxcam.png";
import walletLogo from "../assets/technology_logo/wallet.png";

// Technology data with categories
const TECHNOLOGIES = {
  mobile: {
    title: "Mobile Development",
    icon: Smartphone,
    items: [
      {
        name: "React Native",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
      },
      {
        name: "iOS Swift",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/swift/swift-original.svg",
      },
      {
        name: "Android Kotlin",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kotlin/kotlin-original.svg",
      },
      {
        name: "Flutter",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg",
      },
      {
        name: "Java",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg",
      },
    ],
  },
  frontend: {
    title: "Frontend",
    icon: Globe,
    items: [
      {
        name: "React JS",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
      },
      {
        name: "Vue.js",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vuejs/vuejs-original.svg",
      },
      {
        name: "Angular",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/angularjs/angularjs-original.svg",
      },
      {
        name: "Next.js",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg",
      },
      {
        name: "TypeScript",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg",
      },
      {
        name: "Tailwind CSS",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tailwindcss/tailwindcss-original.svg",
      },
      {
        name: "Figma",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg",
      },
    ],
  },
  backend: {
    title: "Backend",
    icon: Server,
    items: [
      {
        name: "PHP",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/php/php-original.svg",
      },
      {
        name: "Laravel",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/laravel/laravel-original.svg",
      },
      {
        name: "Ruby on Rails",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/rails/rails-original-wordmark.svg",
      },
      {
        name: "Node.js",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",
      },
      {
        name: "Python",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg",
      },
      {
        name: "Django",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/django/django-plain.svg",
      },
      {
        name: "Express.js",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg",
      },
      {
        name: ".NET",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/dotnetcore/dotnetcore-original.svg",
      },
        {
        name: "Java",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg",
      },
      {
        name: "Ruby on Rails",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/rails/rails-plain.svg",
      },
    ],
  },
  database: {
    title: "Database",
    icon: Database,
    items: [
      {
        name: "MySQL",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg",
      },
      {
        name: "PostgreSQL",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg",
      },
      {
        name: "MongoDB",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg",
      },
      {
        name: "Redis",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redis/redis-original.svg",
      },
      {
        name: "Firebase",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain.svg",
      },
      {
        name: "Elasticsearch",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/elasticsearch/elasticsearch-original.svg",
      },
    ],
  },
  ai: {
    title: "AI & Emerging Tech",
    icon: Brain,
    items: [
      {
        name: "TensorFlow",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tensorflow/tensorflow-original.svg",
      },
      {
        name: "PyTorch",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/pytorch/pytorch-original.svg",
      },
      {
        name: "OpenAI",
        logo: TEAM_IMAGES.openai,
      },
      {
        name: "Python ML",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg",
      },
      {
        name: "Arduino IoT",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/arduino/arduino-original.svg",
      },
      {
        name: "Raspberry Pi",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/raspberrypi/raspberrypi-original.svg",
      },
    ],
  },
  cloud: {
    title: "Cloud & DevOps",
    icon: Cloud,
    items: [
      {
        name: "AWS",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/amazonwebservices/amazonwebservices-original-wordmark.svg",
      },
      {
        name: "Google Cloud",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/googlecloud/googlecloud-original.svg",
      },
      {
        name: "Azure",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/azure/azure-original.svg",
      },
      {
        name: "Docker",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg",
      },
      {
        name: "Kubernetes",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kubernetes/kubernetes-plain.svg",
      },
      {
        name: "GitHub Actions",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg",
      },
    ],
  },
  integrations: {
    title: "Integrations",
    icon: Plug,
    items: [
      // Payments
      { name: "Stripe", logo: stripeLogo },
      { name: "PayPal", logo: paypalLogo },
      { name: "Braintree", logo: braintreeLogo },
      { name: "Square", logo: squareLogo },
      { name: "ConnexPay", logo: connexpayLogo },
      { name: "In-App Purchase", logo: appPurchaseLogo },
      { name: "Google Pay", logo: googlePayLogo },
      { name: "Apple Pay", logo: applePayLogo },
      { name: "Google Wallet", logo: googleWalletLogo },
      { name: "Wallet", logo: walletLogo },

      // Identity, risk & data
      { name: "Auth0", logo: auth0Logo },
      { name: "Amazon Cognito", logo: amazonCognitoLogo },
      { name: "Aadhaar", logo: aadhaarLogo },
      { name: "Plaid", logo: plaidLogo },
      { name: "Experian", logo: experianLogo },
      { name: "Kount", logo: kountLogo },

      // Platform & cloud
      { name: "AWS", logo: awsLogo },
      { name: "Firebase", logo: firebaseLogo },
      { name: "Google Maps Platform", logo: googleMapsLogo },
      { name: "OpenWeather", logo: openWeatherLogo },

      // Media & device
      { name: "JW Player", logo: jwPlayerLogo },
      { name: "LottieFiles", logo: lottieFilesLogo },
      { name: "Scandit", logo: scanditLogo },
      { name: "NFC", logo: nfcLogo },
      { name: "Bluetooth Low Energy", logo: bluetoothLogo },

      // Analytics & monitoring
      { name: "Mixpanel", logo: mixpanelLogo },
      { name: "UXCam", logo: uxcamLogo },
      { name: "Bugsnag", logo: bugsnagLogo },
      { name: "Smartlook", logo: smartlookLogo },

      // Protocols
      {
        name: "Socket.io",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/socketio/socketio-original.svg",
      },
      {
        name: "GraphQL",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/graphql/graphql-plain.svg",
      },
      {
        name: "REST APIs",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",
      },
    ],
  },
  qa: {
    title: "Quality Assurance",
    icon: TestTube,
    items: [
      {
        name: "Selenium",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/selenium/selenium-original.svg",
      },
      {
        name: "Cypress",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cypressio/cypressio-original.svg",
      },
      {
        name: "Jest",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jest/jest-plain.svg",
      },
      {
        name: "Mocha",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mocha/mocha-plain.svg",
      },
      {
        name: "Appium",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/android/android-original.svg",
      },
      {
        name: "Postman",
        logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postman/postman-original.svg",
      },
    ],
  },
};

// FAQ Data
const FAQ_DATA = [
  {
    question: "What services does Infotech.Works offer?",
    answer:
      "We offer comprehensive technology services including Mobile App Development (iOS, Android, Cross-platform), Web Application Development, AI & Machine Learning Solutions, IoT Development, Cloud Solutions, UI/UX Design, Quality Assurance, and DevOps services. Our expertise spans across multiple industries and technology stacks.",
  },
  {
    question: "How do you ensure project delivery within the agreed timeline?",
    answer:
      "We follow Agile methodology with 2-week sprint cycles, daily standups, and regular client demos. Our project managers use proven tools for tracking progress, and we maintain transparent communication through weekly status reports.",
  },
  {
    question: "What engagement models do you offer for long-term projects?",
    answer:
      "We offer three flexible engagement models: Fixed Price for well-defined projects with clear scope, Fixed Team (Dedicated Team) for long-term partnerships requiring consistent resources, and Time & Material for projects with evolving requirements.",
  },
  {
    question: "How do you handle communication and project updates?",
    answer:
      "We assign a dedicated Project Manager as your single point of contact. Communication happens through your preferred channels (Slack, Teams, Email). You&apos;ll receive daily updates during active development and weekly progress reports.",
  },
  {
    question: "What technologies and frameworks does your team specialize in?",
    answer:
      "Our team is proficient in React Native, Swift, Kotlin, Flutter for mobile; React, Angular, Vue.js for frontend; Node.js, Python, PHP, .NET for backend; AWS, Azure, Google Cloud for infrastructure; and TensorFlow, PyTorch for AI/ML.",
  },
  {
    question: "Can you scale the team based on project requirements?",
    answer:
      "Absolutely. Our flexible resource model allows us to scale teams up or down based on project phases. We can adjust team composition within 1-2 weeks while maintaining project continuity.",
  },
  {
    question: "What is your quality assurance and testing process?",
    answer:
      "We follow a comprehensive QA process including unit testing, integration testing, system testing, and user acceptance testing. Our QA team works alongside developers from day one, implementing automated testing where applicable.",
  },
  {
    question: "How do you handle data security and confidentiality?",
    answer:
      "Security is paramount. We sign NDAs before project kickoff, implement role-based access controls, use encrypted communication channels, and follow secure coding practices (OWASP guidelines).",
  },
  {
    question: "What happens after the project is delivered?",
    answer:
      "We provide comprehensive post-launch support including a warranty period for bug fixes, knowledge transfer sessions, detailed documentation, and optional maintenance contracts.",
  },
  {
    question: "How do I get started with a new project?",
    answer:
      "Getting started is easy! Contact us through our website or email. We&apos;ll schedule a discovery call to understand your requirements, followed by a detailed proposal with scope, timeline, and cost estimates.",
  },
];

// FAQ Accordion Component
const FAQSection = ({ themeColor }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="inline-flex items-center px-4 py-2 bg-amber-50 text-amber-600 rounded-full text-sm font-semibold mb-4">
            <HelpCircle className="h-4 w-4 mr-2" />
            Got Questions?
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Find answers to common questions about our services, process, and
            engagement
          </p>
        </div>

        <div className="space-y-4">
          {FAQ_DATA.map((faq, index) => (
            <div
              key={index}
              className={`border rounded-2xl overflow-hidden transition-all duration-300 ${
                openIndex === index
                  ? "shadow-lg bg-white"
                  : "border-gray-200 bg-gray-50 hover:border-gray-300"
              }`}
              style={
                openIndex === index ? { borderColor: `${themeColor}40` } : {}
              }
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left"
              >
                <span
                  className={`font-semibold pr-4 ${
                    openIndex === index ? "" : "text-gray-900"
                  }`}
                  style={openIndex === index ? { color: themeColor } : {}}
                >
                  {faq.question}
                </span>
                <div
                  className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-all duration-300 ${
                    openIndex === index ? "rotate-180" : "bg-gray-200"
                  }`}
                  style={
                    openIndex === index
                      ? { backgroundColor: `${themeColor}20` }
                      : {}
                  }
                >
                  <ChevronDown
                    className={`h-5 w-5 ${
                      openIndex === index ? "" : "text-gray-500"
                    }`}
                    style={openIndex === index ? { color: themeColor } : {}}
                  />
                </div>
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? "max-h-96" : "max-h-0"
                }`}
              >
                <div className="px-6 pb-5 text-gray-600 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const IndustryPageTemplate = ({
  industrySlug,
  industryTitle,
  industrySubtitle,
  heroDescription,
  HeroIcon,
  stats,
  serviceOfferings,
  heroImage,
}) => {
  const themeColor = "#b32126";
  const themeColorLight = "#64748b";
  const themeGradient =
    "linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #475569 100%)";
  const [activeTab, setActiveTab] = useState("mobile");
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const heroRef = useRef(null);

  // Get case studies
  const displayCaseStudies = CASE_STUDIES.slice(0, 3);

  // Other industries
  const otherIndustries = INDUSTRIES.filter(
    (i) => i.slug !== industrySlug
  ).slice(0, 8);

  // Mouse move effect for hero
  useEffect(() => {
    const handleMouseMove = (e) => {
      if (heroRef.current) {
        const rect = heroRef.current.getBoundingClientRect();
        setMousePosition({
          x: e.clientX - rect.left,
          y: e.clientY - rect.top,
        });
      }
    };

    const heroElement = heroRef.current;
    if (heroElement) {
      heroElement.addEventListener("mousemove", handleMouseMove);
    }

    return () => {
      if (heroElement) {
        heroElement.removeEventListener("mousemove", handleMouseMove);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section with Glassmorphism */}
      <section
        ref={heroRef}
        className="relative min-h-[400px] flex items-center overflow-hidden"
        style={{ background: themeGradient }}
      >
        {/* Animated Background Elements */}
        <div className="absolute inset-0 overflow-hidden">
          {[...Array(20)].map((_, i) => (
            <div
              key={i}
              className="absolute w-2 h-2 bg-white/20 rounded-full animate-pulse"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 2}s`,
                animationDuration: `${2 + Math.random() * 2}s`,
              }}
            />
          ))}

          <svg className="absolute inset-0 w-full h-full opacity-10">
            <defs>
              <pattern
                id="grid"
                width="60"
                height="60"
                patternUnits="userSpaceOnUse"
              >
                <path
                  d="M 60 0 L 0 0 0 60"
                  fill="none"
                  stroke="white"
                  strokeWidth="0.5"
                />
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#grid)" />
          </svg>

          <div
            className="absolute w-96 h-96 rounded-full opacity-30 blur-3xl"
            style={{
              background: `radial-gradient(circle, ${themeColor} 0%, transparent 70%)`,
              left: mousePosition.x - 192,
              top: mousePosition.y - 192,
              transition: "left 0.3s ease-out, top 0.3s ease-out",
            }}
          />
        </div>

        {/* Hero Content */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 py-16">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <Link
                to="/industries"
                className="inline-flex items-center text-white/70 hover:text-white mb-6 transition-colors"
              >
                <ArrowRight className="h-4 w-4 mr-2 rotate-180" />
                Back
              </Link>

              <div
                className="inline-flex items-center px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-sm font-medium mb-6"
                style={{ color: themeColorLight }}
              >
                <HeroIcon className="h-4 w-4 mr-2" />
                Industry Expertise
              </div>

              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
                {industryTitle}
                <span className="block" style={{ color: themeColor }}>
                  {industrySubtitle}
                </span>
              </h1>

              <p className="text-xl text-white/80 mb-8 leading-relaxed">
                {heroDescription}
              </p>

              <Link
                to="/contact"
                className="inline-flex items-center px-8 py-4 bg-[#b32126] text-white font-semibold rounded-xl hover:bg-[#8f1a1f] transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-1"
              >
                Discuss Your Project
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </div>

            <div className="hidden lg:block">
              <div className="relative">
                <div
                  className="absolute inset-0 rounded-3xl blur-2xl opacity-30"
                  style={{
                    background: `linear-gradient(to right, ${themeColor}, ${themeColorLight})`,
                  }}
                />
                {/* <div className="relative bg-white/10 backdrop-blur-lg rounded-3xl p-8 border border-white/20">
                  <div className="grid grid-cols-2 gap-6">
                    {stats.map((stat, index) => (
                      <div key={index} className="text-center">
                        <div className="text-3xl font-bold text-white mb-1">
                          {stat.value}
                        </div>
                        <div className="text-white/70 text-sm">
                          {stat.label}
                        </div>
                      </div>
                    ))}
                  </div>
                </div> */}

                <div className="hidden lg:flex justify-center items-center relative">
                  <div className="relative w-full h-[400px]">
                    <div
                      className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 rounded-full blur-3xl opacity-30"
                      style={{ background: "#b32126" }}
                    />
                    <img
                      src={heroImage}
                      alt="AI Studio Platform"
                      className="relative z-10 w-full h-full object-cover rounded-2xl shadow-2xl border-4 border-gray-700"
                    />
                    {/* <div className="absolute -bottom-4 -right-4 bg-[#b32126] text-white p-4 rounded-xl shadow-lg z-20">
                      <div className="text-2xl font-bold">10x</div>
                      <div className="text-sm">Faster Prototyping</div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How We Help Section */}
      <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <span
              className="inline-flex items-center px-4 py-2 rounded-full text-sm font-semibold mb-4"
              style={{ backgroundColor: `${themeColor}15`, color: themeColor }}
            >
              How We Help
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Our Services for {industryTitle}
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              End-to-end development services tailored to the unique needs of
              the {industryTitle.toLowerCase()} industry
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {serviceOfferings.map((service, index) => {
              const IconComponent = service.icon;
              return (
                <div
                  key={index}
                  className="group relative bg-white p-6 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 overflow-hidden"
                  style={{ "--hover-border": `${themeColor}40` }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.borderColor = `${themeColor}40`)
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.borderColor = "#f3f4f6")
                  }
                >
                  <div
                    className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity"
                    style={{
                      background: `linear-gradient(to bottom right, ${themeColor}08, ${themeColor}05)`,
                    }}
                  />

                  <div className="relative z-10">
                    <div
                      className="w-14 h-14 rounded-xl flex items-center justify-center mb-4 shadow-lg group-hover:scale-110 transition-transform"
                      style={{
                        background:
                          "linear-gradient(135deg, #d64449 0%, #b32126 50%, #8f1a1f 100%)",
                      }}
                    >
                      <IconComponent className="h-7 w-7 text-white" />
                    </div>
                    <h3
                      className="text-lg font-bold text-gray-900 mb-2 group-hover:transition-colors"
                      style={{ "--hover-color": themeColor }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.color = themeColor)
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.color = "#111827")
                      }
                    >
                      {service.title}
                    </h3>
                    <p className="text-gray-600 text-sm">
                      {service.description}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Explore Other Industries */}
      <section className="py-8 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between mb-8">
            <h2 className="text-2xl font-bold text-gray-900">
              Explore Other Industries
            </h2>
            <Link
              to="/industries"
              className="font-medium flex items-center"
              style={{ color: themeColor }}
            >
              View All <ChevronRight className="h-4 w-4 ml-1" />
            </Link>
          </div>

          <div className="flex overflow-x-auto gap-4 pb-4 scrollbar-hide">
            {otherIndustries.map((industry) => (
              <Link
                key={industry.slug}
                to={`/industries/${industry.slug}`}
                className="flex-shrink-0 bg-gray-50 hover:bg-gray-100 px-6 py-4 rounded-xl border border-gray-200 transition-all group"
                style={{ "--hover-border": `${themeColor}40` }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = `${themeColor}40`;
                  e.currentTarget.style.backgroundColor = `${themeColor}08`;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = "#e5e7eb";
                  e.currentTarget.style.backgroundColor = "#f9fafb";
                }}
              >
                <span
                  className="font-medium text-gray-700 whitespace-nowrap group-hover:transition-colors"
                  style={{ "--hover-color": themeColor }}
                >
                  {industry.title}
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* What We Do Summary */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span
              className="inline-flex items-center px-4 py-2 rounded-full text-sm font-semibold mb-4"
              style={{ backgroundColor: `${themeColor}15`, color: themeColor }}
            >
              Our Services
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              What We Do
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Comprehensive service offerings to bring your{" "}
              {industryTitle.toLowerCase()} platform to life
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-8">
            <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
              <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center">
                <div className="w-10 h-10 bg-red-50 rounded-lg flex items-center justify-center mr-3">
                  <Briefcase className="h-5 w-5 text-[#b32126]" />
                </div>
                Service Bundles
              </h3>
              <div className="space-y-3">
                {SERVICE_BUNDLES.map((service) => (
                  <Link
                    key={service.slug}
                    to={`/what-we-do/${service.slug}`}
                    className="flex items-center justify-between p-4 rounded-xl hover:bg-gray-50 transition-colors group"
                  >
                    <span className="font-medium text-gray-700 group-hover:text-[#b32126]">
                      {service.title}
                    </span>
                    <ChevronRight className="h-5 w-5 text-gray-400 group-hover:text-[#b32126]" />
                  </Link>
                ))}
              </div>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
              <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center">
                <div className="w-10 h-10 bg-red-50 rounded-lg flex items-center justify-center mr-3">
                  <Plug className="h-5 w-5 text-[#b32126]" />
                </div>
                Individual Services
              </h3>
              <div className="grid grid-cols-2 gap-2">
                {INDIVIDUAL_SERVICES.slice(0, 8).map((service) => (
                  <Link
                    key={service.slug}
                    to={`/what-we-do/${service.slug}`}
                    className="p-3 rounded-lg hover:bg-gray-50 transition-colors group"
                  >
                    <span className="text-sm font-medium text-gray-600 group-hover:text-[#b32126]">
                      {service.title}
                    </span>
                  </Link>
                ))}
              </div>
              <Link
                to="/what-we-do"
                className="inline-flex items-center text-[#b32126] font-medium mt-4 hover:text-[#8f1a1f]"
              >
                View All Services <ChevronRight className="h-4 w-4 ml-1" />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Success Stories */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="inline-flex items-center px-4 py-2 bg-green-50 text-green-600 rounded-full text-sm font-semibold mb-4">
              Proven Results
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Success Stories
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              See how we&apos;ve helped businesses in the{" "}
              {industryTitle.toLowerCase()} sector achieve their goals
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {displayCaseStudies.map((study, index) => (
              <Link
                key={study.id}
                to={`/resources/case-studies/${study.slug}`}
                className={`group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all border border-gray-100 ${
                  index === 0 ? "ring-2 ring-offset-2" : ""
                }`}
                style={index === 0 ? { "--tw-ring-color": themeColor } : {}}
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={study.image}
                    alt={study.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute top-4 left-4 flex gap-2">
                    <span className="px-3 py-1 bg-[#b32126] text-white text-xs font-semibold rounded-full">
                      {study.industry}
                    </span>
                    {index === 0 && (
                      <span
                        className="px-3 py-1 text-white text-xs font-semibold rounded-full"
                        style={{ backgroundColor: themeColor }}
                      >
                        Featured
                      </span>
                    )}
                  </div>
                  <div className="absolute top-4 right-4">
                    <span className="px-3 py-1 bg-white/90 text-gray-700 text-xs font-medium rounded-full">
                      {study.timeline}
                    </span>
                  </div>
                </div>
                <div className="p-6">
                  <p className="text-sm text-gray-500 mb-1">
                    {study.clientType}
                  </p>
                  <h3
                    className="text-xl font-bold text-gray-900 mb-2 group-hover:transition-colors"
                    style={{ "--hover-color": themeColor }}
                  >
                    {study.title}
                  </h3>
                  <p className="text-gray-600 text-sm mb-4 line-clamp-2">
                    {study.tagline}
                  </p>
                  <div className="flex flex-wrap gap-2">
                    {study.results.slice(0, 3).map((result, idx) => (
                      <span
                        key={idx}
                        className="text-xs bg-green-50 text-green-700 px-2.5 py-1 rounded-full font-medium"
                      >
                        {result.value} {result.label}
                      </span>
                    ))}
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <div className="text-center mt-10">
            <Link
              to="/resources/case-studies"
              className="inline-flex items-center px-6 py-3 border-2 font-semibold rounded-lg hover:text-white transition-colors"
              style={{ borderColor: themeColor, color: themeColor }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = themeColor;
                e.currentTarget.style.color = "white";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "transparent";
                e.currentTarget.style.color = themeColor;
              }}
            >
              View All Case Studies
              <ArrowRight className="ml-2 h-5 w-5" />
            </Link>
          </div>
        </div>
      </section>

      {/* Technologies Section - Tabbed */}
      <section className="py-20 bg-gradient-to-b from-gray-900 to-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            {/* <span
              className="inline-flex items-center px-4 py-2 bg-white/10 rounded-full text-sm font-semibold mb-4"
              style={{ color: themeColorLight }}
            >
              Tech Stack
            </span> */}
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Technologies We Use
            </h2>
            <p className="text-lg text-gray-400 max-w-2xl mx-auto">
              Industry-leading tools and frameworks to build robust{" "}
              {industryTitle.toLowerCase()} platforms
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-2 mb-10">
            {Object.entries(TECHNOLOGIES)
              .sort(([, a], [, b]) => a.title.localeCompare(b.title))
              .map(([key, category]) => {
              const IconComponent = category.icon;
              return (
                <button
                  key={key}
                  onClick={() => setActiveTab(key)}
                  className={`flex items-center px-5 py-3 rounded-xl font-medium transition-all ${
                    activeTab === key
                      ? "text-white shadow-lg"
                      : "bg-white/10 text-gray-300 hover:bg-white/20"
                  }`}
                  style={
                    activeTab === key ? { backgroundColor: themeColor } : {}
                  }
                >
                  <IconComponent className="h-5 w-5 mr-2" />
                  {category.title}
                </button>
              );
            })}
          </div>

          <div className="bg-white/5 backdrop-blur-sm rounded-3xl p-8 border border-white/10">
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6">
              {TECHNOLOGIES[activeTab].items.map((tech, index) => (
                <div
                  key={tech.name}
                  className="group flex flex-col items-center p-4 bg-white/5 rounded-xl hover:bg-white/10 transition-all"
                >
                  <div className="w-24 h-20 flex items-center justify-center mb-3 bg-white rounded-xl p-3 group-hover:scale-110 transition-transform shadow-lg">
                    <img
                      src={tech.logo}
                      alt={tech.name}
                      className="max-w-full max-h-full object-contain"
                      onError={(e) => {
                        e.target.style.display = "none";
                      }}
                    />
                  </div>
                  <span className="text-white text-sm font-medium text-center">
                    {tech.name}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Engagement Model Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span
              className="inline-flex items-center px-4 py-2 rounded-full text-sm font-semibold mb-4"
              style={{ backgroundColor: `${themeColor}15`, color: themeColor }}
            >
              Flexible Partnership
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Engagement Models
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Choose the partnership model that best fits your project needs and
              business goals
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <Link
              to="/what-we-do/engagement-model#fixed-price"
              className="group relative bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all border border-gray-100 hover:border-emerald-200 overflow-hidden"
            >
              <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-emerald-500/10 to-teal-500/10 rounded-full -mr-16 -mt-16 group-hover:scale-150 transition-transform duration-500" />
              <div className="relative">
                <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-emerald-500 to-teal-600 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                  <DollarSign className="h-8 w-8 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-emerald-600 transition-colors">
                  Fixed Price
                </h3>
                <p className="text-gray-600 mb-4">
                  Predictable budgets with well-defined scope. Ideal for
                  projects with clear requirements.
                </p>
                <ul className="space-y-2 mb-6">
                  <li className="flex items-center text-sm text-gray-500">
                    <ChevronRight className="h-4 w-4 text-emerald-500 mr-2" />
                    Budget certainty upfront
                  </li>
                  <li className="flex items-center text-sm text-gray-500">
                    <ChevronRight className="h-4 w-4 text-emerald-500 mr-2" />
                    Milestone-based delivery
                  </li>
                  <li className="flex items-center text-sm text-gray-500">
                    <ChevronRight className="h-4 w-4 text-emerald-500 mr-2" />
                    Clear deliverables
                  </li>
                </ul>
                <span className="inline-flex items-center text-emerald-600 font-medium group-hover:translate-x-2 transition-transform">
                  Learn More <ArrowRight className="ml-2 h-4 w-4" />
                </span>
              </div>
            </Link>

            <Link
              to="/what-we-do/engagement-model#fixed-team"
              className="group relative bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all border border-gray-100 hover:border-blue-200 overflow-hidden"
            >
              <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-blue-500/10 to-indigo-500/10 rounded-full -mr-16 -mt-16 group-hover:scale-150 transition-transform duration-500" />
              <div className="relative">
                <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                  <Users className="h-8 w-8 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors">
                  Fixed Team
                </h3>
                <p className="text-gray-600 mb-4">
                  Dedicated team working exclusively on your project. Perfect
                  for long-term partnerships.
                </p>
                <ul className="space-y-2 mb-6">
                  <li className="flex items-center text-sm text-gray-500">
                    <ChevronRight className="h-4 w-4 text-blue-500 mr-2" />
                    Dedicated resources
                  </li>
                  <li className="flex items-center text-sm text-gray-500">
                    <ChevronRight className="h-4 w-4 text-blue-500 mr-2" />
                    Deep domain expertise
                  </li>
                  <li className="flex items-center text-sm text-gray-500">
                    <ChevronRight className="h-4 w-4 text-blue-500 mr-2" />
                    Seamless integration
                  </li>
                </ul>
                <span className="inline-flex items-center text-blue-600 font-medium group-hover:translate-x-2 transition-transform">
                  Learn More <ArrowRight className="ml-2 h-4 w-4" />
                </span>
              </div>
            </Link>

            <Link
              to="/what-we-do/engagement-model#time-and-material"
              className="group relative bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all border border-gray-100 hover:border-purple-200 overflow-hidden"
            >
              <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-purple-500/10 to-violet-500/10 rounded-full -mr-16 -mt-16 group-hover:scale-150 transition-transform duration-500" />
              <div className="relative">
                <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-purple-500 to-violet-600 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                  <Clock className="h-8 w-8 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-purple-600 transition-colors">
                  Time & Material
                </h3>
                <p className="text-gray-600 mb-4">
                  Maximum flexibility for evolving requirements. Pay for actual
                  time and resources used.
                </p>
                <ul className="space-y-2 mb-6">
                  <li className="flex items-center text-sm text-gray-500">
                    <ChevronRight className="h-4 w-4 text-purple-500 mr-2" />
                    Complete flexibility
                  </li>
                  <li className="flex items-center text-sm text-gray-500">
                    <ChevronRight className="h-4 w-4 text-purple-500 mr-2" />
                    Transparent billing
                  </li>
                  <li className="flex items-center text-sm text-gray-500">
                    <ChevronRight className="h-4 w-4 text-purple-500 mr-2" />
                    Scale as needed
                  </li>
                </ul>
                <span className="inline-flex items-center text-purple-600 font-medium group-hover:translate-x-2 transition-transform">
                  Learn More <ArrowRight className="ml-2 h-4 w-4" />
                </span>
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <FAQSection themeColor={themeColor} />

      {/* CTA Section */}
      <section
        className="py-20 relative overflow-hidden"
        style={{
          background: `linear-gradient(to right, ${themeColor}, ${themeColorLight})`,
        }}
      >
        <div className="absolute inset-0 opacity-10">
          <svg className="w-full h-full">
            <defs>
              <pattern
                id="cta-pattern"
                width="40"
                height="40"
                patternUnits="userSpaceOnUse"
              >
                <circle cx="20" cy="20" r="2" fill="white" />
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#cta-pattern)" />
          </svg>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Ready to Transform Your {industryTitle} Business?
          </h2>
          <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Let&apos;s create powerful technology solutions that drive growth
            and innovation
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center px-8 py-4 bg-white font-semibold rounded-xl hover:bg-gray-100 transition-colors shadow-lg"
              style={{ color: themeColor }}
            >
              Start Your Project
              <ArrowRight className="ml-2 h-5 w-5" />
            </Link>
            <Link
              to="/resources/case-studies"
              className="inline-flex items-center justify-center px-8 py-4 bg-transparent border-2 border-white text-white font-semibold rounded-xl hover:bg-white/10 transition-colors"
            >
              View Case Studies
            </Link>
          </div>
        </div>
      </section>

      <style>{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>
  );
};

export default IndustryPageTemplate;
